<div class="row">
    <div class="col-24">
        <div>
            <h1>Hello {{userName}}. You are submitting an enrollment for Plan Year {{planyear}} </h1>
        </div>
    </div>
</div>
<div class="row">
    <a (click)="homeClick()"><u>Go to Home Page</u></a>

</div>
<div class="row">

    <a (click)="dataEntryClick()"><u>Go to Data Entry for Paper Application</u></a>

</div>

<div class="row">
    <a (click)="eappClick()"><u>Go to Electronic Application</u></a>

</div>
<div class="row">
    <a (click)="callScriptClick()"><u>Go to Call Script Access</u></a>

</div>
<div class="row">
    <a (click)="esoaClick()"><u>Go to Electronic Scope of Application</u></a>

</div>